import { render, staticRenderFns } from "./AtendimentosIcon.vue?vue&type=template&id=61f26832"
import script from "./AtendimentosIcon.vue?vue&type=script&lang=js"
export * from "./AtendimentosIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports